import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-toolbox/lib/button';
import Link from 'react-router-dom/Link';
import Input from 'react-toolbox/lib/input';
import { getErrorMessageByCode } from '../errors';
import formStyles from './Form.scss';

const propTypes = {
  error: PropTypes.string,
  onEmailBlur: PropTypes.func,
  onSubmit: PropTypes.func,
};

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      username: '',
      password: '',
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.state, e);
  }

  handleInputChange(value, e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    const { error, onEmailBlur } = this.props;

    return (
      <form
        id="login-form"
        className={formStyles.loginFormInput}
        action="/check"
        method="post"
        onSubmit={this.handleSubmit}
      >
        <Input
          login
          className={formStyles.loginInput}
          id="username"
          name="username"
          onBlur={onEmailBlur}
          placeholder="E-mail"
          autoComplete="off"
          value={this.state.username}
          onChange={this.handleInputChange}
        />
        <Input
          className={formStyles.loginInput}
          id="password"
          type="password"
          name="password"
          placeholder="Password"
          autoComplete="off"
          value={this.state.password}
          onChange={this.handleInputChange}
        />

        {error && (
          <p className={`text--left ${formStyles.error}`}>
            {getErrorMessageByCode(error)}
          </p>
        )}
        <div className={formStyles.footer}>
          <Button
            login
            raised
            type="submit"
            className={formStyles.footerLoginSubmit}
            form="login-form"
          >
            LOG IN
          </Button>
          <Link to="/forgot-password" className={formStyles.forgotPasswordLink}>
            Forgot password?
          </Link>
        </div>
      </form>
    );
  }
}

LoginForm.propTypes = propTypes;

export default LoginForm;



// WEBPACK FOOTER //
// ./src/client/src/components/LoginForm.js